import { createContext, useContext } from 'react';
import type { LiveTimeBlock, Settings } from '@wiztime/core';
import type { ProjectsView } from '../../hooks/useProjects';
import type { Conflicts, DisplayGroup } from './timeline/laneModel';

/** Everything the day view's cards and timeline read, loaded once per viewed date. */
export interface DayData {
  readonly date: string;
  readonly settings: Settings;
  readonly projects: ProjectsView;
  /** Visible blocks and drafts of the date, ordered by start. */
  readonly blocks: readonly LiveTimeBlock[];
  readonly blocksLoading: boolean;
  readonly blocksError: unknown;
  readonly retryBlocks: () => void;
  readonly groups: readonly DisplayGroup[];
  readonly conflicts: Conflicts;
  /** Current time, refreshed every 30 seconds. */
  readonly now: number;
}

export const DayDataContext = createContext<DayData | null>(null);

export function useDayData(): DayData {
  const data = useContext(DayDataContext);
  if (data === null) throw new Error('DayDataContext is missing');
  return data;
}
